import {IScanner, IScannerSettings, IScanOptions, IScanResult} from './contracts';
import {IScanService} from '@techsee/techsee-client-infra/lib/services/ScanService';

export default abstract class Scanner implements IScanner {
    protected _name: string;
    protected _endpoint: string;

    protected constructor(
        public settings: IScannerSettings,
        protected _roomId: string,
        protected _scanService: IScanService,
        protected language: string
    ) {
        this._name = settings.name;
        this._endpoint = settings.endpoint;
    }

    get type(): string {
        return this._name;
    }

    async scan(
        image: string,
        takenFrom: string,
        notifyExternal = false,
        imageUrl?: string,
        thumbnail?: string
    ): Promise<IScanResult> {
        try {
            //@ts-ignore
            const result = await this._scanService.scan(
                image,
                takenFrom,
                this._roomId,
                this.language as string,
                thumbnail,
                notifyExternal,
                imageUrl
            );
            return result as IScanResult;
        } catch (error) {
            return {text: {raw: '', lines: []}}; // Return empty result on failure
            // Return empty result on failure
        }
    }
}
